// @constants
const actionTypes = require('../raConstants/actionTypes');

const updateObjective = title => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_UPDATE_DESCRIPTION,
    payload: {
        title,
    },
});

const setObjectiveAmount = amount => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_AMOUNT,
    payload: {
        amount,
    },
});

const setObjectiveEndDate = date => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_OBJECTIVE_END_DATE,
    payload: {
        date,
    },
});

const setObjectiveEndDateError = () => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_END_DATE_ERROR_ENABLED,
});

const setInitialContributionAmount = investment => ({
    type:
        actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_INITIAL_CONTRIBUTION_AMOUNT,
    payload: {
        investment,
    },
});

const setRecurringContributionAmount = amount => ({
    type:
        actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_RECURRING_CONTRIBUTION_AMOUNT,
    payload: {
        amount,
    },
});

const setPeriodicity = periodicity => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_PERIODICITY,
    payload: {
        periodicity,
    },
});

const setContributionDay = day => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_CONTRIBUTION_DAY,
    payload: {
        day,
    },
});

const setSelectedStrategy = id => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SET_SELECTED_STRATEGY,
    payload: id,
});

const getSimulation = () => (dispatch, getState) => {
    const immSimulation = getState().raSimulation.get('simulation');

    dispatch({
        type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_DATA_FROM_SIMULATION,
        payload: immSimulation,
    });
};

const saveSimulationChangeModalOption = value => ({
    type: actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_CHANGE_MODAL_OPTION,
    payload: { value },
});

const disableSaveSimulationButton = value => ({
    type: actionTypes.RA_SAVE_SIMULATION_OBJECTIVE_DISABLE_SIMULATION_BUTTON,
    payload: { value },
});

const reset = () => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_RESET,
});

const resetSchemeContribution = () => ({
    type: actionTypes.RA_CUSTOM_PLAN_BY_OBJECTIVE_SCHEME_CONTRIBUTION_RESET,
});

const setScrollHeight = () => ({
    type: actionTypes.RA_SIMULATION_SET_SCROLL_HEIGHT,
});

module.exports = {
    disableSaveSimulationButton,
    getSimulation,
    reset,
    resetSchemeContribution,
    setObjectiveAmount,
    setObjectiveEndDate,
    setObjectiveEndDateError,
    setInitialContributionAmount,
    setRecurringContributionAmount,
    setPeriodicity,
    setContributionDay,
    setSelectedStrategy,
    updateObjective,
    saveSimulationChangeModalOption,
    setScrollHeight,
};
